module.exports = __webpack_public_path__ + "img/2.d7f6d716.jpg";